// Roll tiling for print-ready panel files. A panel plus its bleed is split
// into printable tiles that each fit across the vinyl roll, with `overlapIn`
// shared between neighbouring tiles so installers can lap the seams. Used by
// the server's panel print files and the spec PDF's panel table, so both
// always agree on how a panel is cut.
// Longest page edge written into a print PDF. Acrobat and several RIPs
// reject or silently rescale pages past 200 in (14400 pt), so a tile is also
// split along the roll when its length would exceed this.
export const PRINT_MAX_PAGE_IN = 200;
// Splits `length` into the fewest equal pieces no longer than `maxPiece`,
// neighbours sharing `overlap`. Returns each piece's start offset and the
// common piece length.
function split(length, maxPiece, overlap) {
    if (length <= maxPiece)
        return { count: 1, piece: length, starts: [0] };
    const step = Math.max(1, maxPiece - overlap);
    const count = Math.ceil((length - overlap) / step);
    const piece = (length + (count - 1) * overlap) / count;
    const starts = Array.from({ length: count }, (_, i) => i * (piece - overlap));
    return { count, piece, starts };
}
/** Plans the tiles for one panel. Tries horizontal seams (strips stacked
 * top to bottom, each roll-width tall) and vertical seams (strips side by
 * side, each roll-width wide), keeps whichever needs fewer tiles, and
 * prefers horizontal on a tie: those seams follow body lines and shed water
 * when the upper strip laps the lower one. */
export function planPanelTiles(panel, opts) {
    const bleedRect = { x: panel.x - opts.bleedIn, y: panel.y - opts.bleedIn, w: panel.w + 2 * opts.bleedIn, h: panel.h + 2 * opts.bleedIn };
    const roll = Math.min(opts.rollWidthIn, PRINT_MAX_PAGE_IN);
    const horizontal = { rows: split(bleedRect.h, roll, opts.overlapIn), cols: split(bleedRect.w, PRINT_MAX_PAGE_IN, opts.overlapIn) };
    const vertical = { rows: split(bleedRect.h, PRINT_MAX_PAGE_IN, opts.overlapIn), cols: split(bleedRect.w, roll, opts.overlapIn) };
    const count = (p) => p.rows.count * p.cols.count;
    const useVertical = count(vertical) < count(horizontal);
    const { rows, cols } = useVertical ? vertical : horizontal;
    const tiles = [];
    rows.starts.forEach((top, row) => {
        cols.starts.forEach((left, col) => {
            tiles.push({ row, col, x: bleedRect.x + left, y: bleedRect.y + top, w: cols.piece, h: rows.piece });
        });
    });
    let seams = 'none';
    if (rows.count > 1 && cols.count > 1)
        seams = 'grid';
    else if (rows.count > 1)
        seams = 'horizontal';
    else if (cols.count > 1)
        seams = 'vertical';
    return { seams, rows: rows.count, cols: cols.count, bleedRect, tiles };
}
//# sourceMappingURL=tiling.js.map